import React from "react";
import { PhoneCallIcon } from "lucide-react";
import styles from "./FloatingButtons.module.css";

type CallButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  className?: string;
  phone?: string;
};

const DEFAULT_PHONE = "+49 30 3743 6370";

const CallButton: React.FC<CallButtonProps> = ({
  className,
  phone = DEFAULT_PHONE,
  onClick,
  ...rest
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    e.currentTarget.blur();
  };

  return (
    <a
      href={`tel:${phone.replace(/\s+/g, "")}`}
      className={[styles.floatingButton, className].filter(Boolean).join(" ")}
      onClick={handleClick}
      aria-label="Anrufen"
      {...rest}
    >
      <PhoneCallIcon size={22} aria-hidden="true" focusable="false" />
    </a>
  );
};

export default CallButton;
